<div id="runEvent" style="margin-top: 3rem;">
    <app-header title=""></app-header>
    <div class="">
        <div id="inPersonEventReportName" class="px-4 pb-0 pt-3 paybee-modal-header--regular-important headline-4" style="border-bottom: none!important;">Event Name</div>
        <ul class="nav nav-tabs md-tabs md-tabs--paybee paybee-modal-header--regular-important px-4 pb-0 pt-5">
            <li class="nav-item nav-item-important">
                <a class="nav-link nav-link-important" data-toggle="tab" href="#paneIAtAGlace" role="tab">At A Glance</a>
            </li>
            <li class="nav-item nav-item-important">
                <a class="nav-link active nav-link-important" data-toggle="tab" href="#panelIAttendees" role="tab">Attendees</a>
            </li>
            <li class="nav-item nav-item-important">
                <a class="nav-link nav-link-important" data-toggle="tab" href="#panelIPaddles" role="tab">Paddles</a>
            </li>
            <li class="nav-item nav-item-important">
                <a id="panelInPersonEventPageInviteTab" class="nav-link nav-link-important" data-toggle="tab" href="#panelInPersonEventPageInvite" role="tab">Event Page Invitations</a>
            </li>
            <li class="nav-item nav-item-important">
                <a (click)="showRemindersPage()" id="panelInPersonRemindersTab" class="nav-link nav-link-important" data-toggle="tab" href="#panelInPersonReminders" role="tab">Reminders</a>
            </li>
        </ul>
        <div class="tab-content tab-content-important">
            <div class="tab-pane fade" id="paneIAtAGlace" role="tabpanel">
                <div class="col-12">
                    <div class="d-flex">
                        <div class="d-block w-100">
                            <div class="ticket-summary__holder headline-5 mb-2 mt-2">At A Glance</div>
                            <div class="ticket-summary__type body-2 grey-text mb-3">Event totals and distribution by campaign.</div>
                        </div>
                        <div class="d-block">
                            <div class="d-flex w-100">
                                <div>
                                    <button id="addCampaignsButton" type="button" class="btn btn-sm modal-cancel-button waves-effect waves-light caption text-nowrap" aria-expanded="false"><i class="fa fa-user-plus mr-2"></i>Add Campaigns...</button>
                                </div>
                                <div>
                                    <button onclick="orgMain.showOpenCartsByTable()" type="button" class="btn btn-sm modal-cancel-button waves-effect waves-light caption text-nowrap" aria-expanded="false"><i class="fas fa-comments mr-2"></i>Carts By Table...</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row text-left eventSummaryRow pl-4 pt-0 pb-0">
                    <div class="col eventSummary pl-4 pt-0 pb-0" style="border: none;font-size: x-small">
                        <small class="muted">Last Updated: </small>
                        <small class="muted" id="lastActivityUpdated"></small>
                    </div>
                </div>
                <div class="row text-center eventSummaryRow pl-4 pr-4 pt-0">
                    <div class="col-6" style="border: none">
                        <div class="row text-center">
                            <div class="col d-flex">
                                <a id="refreshActivity" class="blue-text" onclick="" style="line-height: 33px;"><i class="fas fa-sync"></i></a>
                            </div>
                        </div>
                        <div class="row text-center">
                            <div class="col">
                                <H3>Total</H3>
                                <H1 id="eventSummaryTotal"></H1>
                            </div>
                        </div>
                        <div class="row text-center eventSummaryRow">
                            <div class="col">
                                <span>Pledged</span><br/>
                                <span id="eventSummaryPledged"></span>
                            </div>
                            <div class="col">
                                <span>Pending</span><br/>
                                <span id="eventSummaryPending"></span>
                            </div>
                            <div class="col" style="border: none">
                                <span>Donated</span><br/>
                                <span id="eventSummaryDonated"></span>
                            </div>
                        </div>
                    </div>
                    <div class="col-6 text-center">
                        <canvas class="text-center" id="pieChartEventSummary"></canvas>
                    </div>
                </div>
                <div class="row justify-content-center" style="margin-top: 1rem">
                    <div class="col text-center" id="barChartEventCampaignsCol" style="border-right: 1px solid #00000026;">
                        <canvas class="text-center" id="barChartEventCampaigns"></canvas>
                    </div>
                </div>
                <div class="container">
                    <div class="row justify-content-center">
                        <div class="col">
                            <div class="card">
                                <div class="card-body">
                                    <div class="row justify-content-center" id="campaignDetailRow">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row justify-content-center" style="margin-top: 1rem"></div>
            </div>
            <div class="tab-pane fade in show active" id="panelIAttendees" role="tabpanel">
                <div class="col-12 col-12-important">
                    <div class="d-flex">
                        <div class="d-block w-100">
                            <div class="ticket-summary__holder headline-5 mb-2 mt-2">Attendees <a id="refreshAttendees" class="blue-text ticket-summary__type" onclick=""><i class="fas fa-sync"></i></a></div>
                            <div class="ticket-summary__type body-2 grey-text">List of attendees</div>
                        </div>
                        <div class="d-block">
                            <div class="d-flex w-100">
                                <div>
                                    <button (click)="openBulkCheckoutModal()" class="btn btn-sm modal-cancel-button waves-effect waves-light caption text-nowrap d-flex">
                                        <img class="mr-1 bulk-image" src="images/payment-cards/bulkcheckout.png">
                                        Bulk Checkout...</button>
                                </div>
                                <div>
                                    <button id="addPaddleButton" type="button" class="btn btn-sm modal-cancel-button waves-effect waves-light caption text-nowrap d-flex" aria-expanded="false">Add Pledges...</button>
                                </div>
                                <div>
                                    <button id="addAttendeeButton" type="button" class="btn btn-sm modal-cancel-button waves-effect waves-light caption text-nowrap" aria-expanded="false"><i class="fa fa-user-plus mr-2"></i>Add Attendees...</button>
                                </div>
                                <div>
                                    <button type="button" data-toggle="dropdown" class="btn btn-sm modal-cancel-button waves-effect waves-light caption text-nowrap" aria-expanded="false">
                                        <i class="fas fa-paper-plane mr-2"></i>
                                        <span class="mr-2">Reminders</span>
                                        <i class="fas fa-caret-down"></i>
                                    </button>
                                    <ul class="dropdown-menu dropdown-menu-right" x-placement="bottom-end" style="position: absolute; will-change: transform; top: 0px; left: 0px; transform: translate3d(1424px, 42px, 0px);">
                                        <li class="dropdown-item body-1" id="sendCartReminderAll">
                                            <a>Pending Carts...</a>
                                        </li>
                                        <li class="dropdown-item body-1" id="sendGuestReminderAll">
                                            <a>Event Reminder...</a>
                                        </li>
                                        <li class="dropdown-item body-1" id="sendAddGuestReminderAll">
                                            <a>Add Guest Reminder...</a>
                                            <div id="sendAddGuestReminderAllError" class="caption red-text">Event date is in the past</div>
                                        </li>
                                        <li class="dropdown-item body-1" id="sendSaveCardReminderAll">
                                            <a>Save Card Reminder...</a>
                                            <div id="sendSaveCardReminderAllError" class="caption red-text">Event date is in the past</div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
    
                <div id="eventAttendeesStatistic">
                    <div class="row mx-0 mb-2 mt-4">
                        <div class="d-flex col-12 col-12-important col-sm-6 col-md-4 col-xl-3 justify-content-center mb-2 mb-md-0 offset-md-2 offset-xl-3">
                            <div class="d-flex align-items-center">
                                <i class="fas fa-user mr-2"></i>
                                <div class="body-1 text-nowrap">Total Attendees: <span id="eventTotalAttendeesStatistic">0</span></div>
                            </div>
                        </div>
                        <div class="d-flex col-12 col-12-important col-sm-6 col-md-4 col-xl-3 justify-content-center mb-2 mb-md-0">
                            <div class="d-flex align-items-center">
                                <i class="fas fa-user-check mr-2"></i>
                                <div class="body-1 text-nowrap">Total Checked In: <span id="eventTotalCheckedInStatistic">0</span></div>
                            </div>
                        </div>
                    </div>
                </div>
    
                <div class="col col-12-important" style="margin-bottom: 2rem;">
                    <div class="table--paybee">
                        <table id ="attendeeList" class="table" cellspacing="0" style="width: 100%;">
                            <thead class="thead-light">
                                <tr>
                                    <th>Name</th>
                                    <th>Email</th>
                                    <th class="text-nowrap">First Name</th>
                                    <th class="text-nowrap">Last Name</th>
                                    <th style="white-space: nowrap;">Saved Card</th>
                                    <th>PaddleNum</th>
                                    <th>TableNum</th>
                                    <th>SeatNum</th>
                                    <th>Created</th>
                                    <th class="no-export">Cart</th>
                                    <th>Pending</th>
                                    <th>Donated</th>
                                    <th style="white-space: nowrap;">Checked In</th>
                                    <th style="white-space: nowrap;">Checkout Link</th> 
                                    <th style="white-space: nowrap;">Save Card Link</th>  
                                    <th class="no-export"></th>
                                </tr>
                            </thead>
                        </table>
                    </div>
                </div>
            </div>
            <div class="tab-pane fade" id="panelIPaddles" role="tabpanel">
                <div class="col">
                    <div class="d-flex justify-content-between">
                        <div class="d-block">
                            <div class="ticket-summary__holder headline-5 mb-2 mt-2">Bidder Paddles, Name and Table Cards </div>
                            <div class="ticket-summary__type body-2 grey-text mb-4">Assign and download paddle PDF's ready to print and use.</div>
                        </div>
                        <div class="d-block">
                            <div class="d-flex w-100">
                                <div>
                                    <button id="assignPaddleAll" type="button" class="btn btn-sm modal-cancel-button waves-effect waves-light caption text-nowrap" aria-expanded="false"><i class="fas fa-users mr-2"></i>Assign Paddles to All...</button>
                                    <button id="unassignPaddleAll" type="button" class="btn btn-sm modal-cancel-button waves-effect waves-light caption text-nowrap" aria-expanded="false"><i class="fas fa-user-slash mr-2"></i>Unassign Paddles...</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- Double Sided default paddle -->
                    <div class="card text-center card-body" style="margin-bottom: 2rem;"> 
                        <div class="row">                
                            <div class="col-6">                                                                             
                                <div class="row">
                                    <div class="col text-left">                                                
                                        <h5 class="headline-6">
                                            Double Sided Bidder Paddles
                                        </h5>
                                    </div>
                                </div>
                                <div class="row justify-content-center mb-4" >
                                    <div class="col">                                                                                                
                                        <div class="text-left body-2">Double sided bidder paddle to be used for Paddle Raise and Live Auction.</div>                                                
                                    </div>
                                </div>
                                <div class="row justify-content-center mb-4">
                                    <div class="col col text-left">
                                        <div class="mb-2"><i class="fas fa-print mr-1"></i>Printing instructions </div>
                                        <div class="body-2">
                                            Print it on letter size paper with scale set to 100%.
                                            Fold it in the middle and add a stick to create double sided paddle.
                                        </div>                                                
                                    </div>
                                </div>
                                <div class="row justify-content-center">
                                    <div class="col text-center">
                                        <button class="btn btn--paybee btn--purple button waves-effect waves-light" id="pdfPaddlePreview" style="display: initial;">
                                            <i class="fas fa-download mr-2"></i>View and Download
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div class="col-6" style="border-right: #ddd;border-right-style: solid;border-right-width: 0.25px;">
                                <div class="row">
                                    <div class="col-6 text-left body-2">
                                        Front Image
                                        <img class="img-fluid paddle_preview_image" src="/images/paddle_image_front_back.png" alt="user image" style="width: 100%">
                                    </div>
                                    <div class="col-6 text-left body-2">
                                        Back Image
                                        <img class="img-fluid paddle_preview_image" src="/images/paddle_image_front_back.png" alt="user image" style="width: 100%">
                                    </div>
                                </div>                                        
                            </div>                                    
                        </div>
                    </div>
                    <!-- One Sided/Other side image paddle -->
                    <div class="card text-center card-body" style="margin-bottom: 2rem;"> 
                        <div class="row">                
                            <div class="col-6">                                                                             
                                <div class="row">
                                    <div class="col text-left">                                                
                                        <h5 class="headline-6">
                                            One Side Image Bidder Paddles
                                        </h5>
                                    </div>
                                </div>
                                <div class="row justify-content-center mb-4" >
                                    <div class="col">                                                                                                
                                        <div class="text-left body-2">
                                            Bidder paddles with one side replaced with image provided, to be used for Paddle Raise and Live Auction.
                                        </div>
                                    </div>
                                </div>
                                <div class="row justify-content-center mb-4">
                                    <div class="col col text-left">
                                        <div class="mb-2"><i class="fas fa-print mr-1"></i>Printing instructions </div>
                                        <div class="body-2">
                                            Print it on letter size paper with scale set to 100%.
                                            Fold it in the middle and add stick to create double sided paddle.
                                        </div>                                                
                                    </div>
                                </div>
                                <div class="row justify-content-center">
                                    <div class="col text-center">
                                        <button class="btn btn--paybee btn--purple button waves-effect waves-light" id="pdfOneSidedImagePaddlePreview" style="display: initial;">
                                            <i class="fas fa-download mr-2"></i>View and Download
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div class="col-6" style="border-right: #ddd;border-right-style: solid;border-right-width: 0.25px;">
                                <div class="row">
                                    <div class="col-6 text-left body-2">
                                        Front Image
                                        <img class="img-fluid paddle_preview_image" src="/images/paddle_image_front_back.png" alt="user image" style="width: 100%">
                                    </div>
                                    <div class="col-6 text-left body-2">
                                        Back Image
                                        <div class="file-field">
                                            <div class="d-flex justify-content-left">
                                                <div class="btn btn-flat waves-effect waves-effect p-0 m-0 w-100">
                                                    <img class="img-fluid paddle_preview_image" id="paddleBackImage" src="/images/one_side_image_place_holder.png" alt="user image" style="width: 100%">
                                                    <input id="uploadPaddleImage" type="file" onclick="this.value=null;">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="text-center body-2 mt-1">Click on image to add/update</div>
                                    </div>
                                </div>
                            </div>                                    
                        </div>
                    </div>
                    <!-- One Sided default paddle -->
                    <div class="card text-center card-body" style="margin-bottom: 2rem;"> 
                        <div class="row">                
                            <div class="col-6">                                                                             
                                <div class="row">
                                    <div class="col text-left">                                                
                                        <h5 class="headline-6">
                                            One Sided Bidder Paddles
                                        </h5>
                                    </div>
                                </div>
                                <div class="row justify-content-center mb-4" >
                                    <div class="col">                                                                                                
                                        <div class="text-left body-2">One sided bidder paddle.</div>                                                
                                    </div>
                                </div>
                                <div class="row justify-content-center mb-4">
                                    <div class="col col text-left">
                                        <div class="mb-2"><i class="fas fa-print mr-1"></i>Printing instructions </div>
                                        <div class="body-2">
                                            Print it on letter size paper with scale set to 100%. Each page has two paddles. Use for paddles behind the program.
                                        </div>
                                    </div>
                                </div>
                                <div class="row justify-content-center">
                                    <div class="col text-center">
                                        <button class="btn btn--paybee btn--purple button waves-effect waves-light" id="pdfOneSidedPaddlePreview" style="display: initial;">
                                            <i class="fas fa-download mr-2"></i>View and Download
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div class="col-6" style="border-right: #ddd;border-right-style: solid;border-right-width: 0.25px;">
                                <div class="row">
                                    <div class="col-6 text-left body-2">
                                        Front Image
                                        <img class="img-fluid paddle_preview_image" src="/images/paddle_image_front_back.png" alt="user image" style="width: 100%">
                                    </div>
                                    <div class="col-6 text-left body-2">                                                
                                    </div>
                                </div>                                        
                            </div>                                    
                        </div>
                    </div>
                    <!-- Full Page double sided Paddles -->
                    <div class="card text-center card-body" style="margin-bottom: 2rem;"> 
                        <div class="row">                
                            <div class="col-6">                                                                             
                                <div class="row">
                                    <div class="col text-left">                                                
                                        <h5 class="headline-6">
                                            Double Sided Full Page (Letter/A4) Bidder Paddles
                                        </h5>
                                    </div>
                                </div>
                                <div class="row justify-content-center mb-4" >
                                    <div class="col">                                                                                                
                                        <div class="text-left body-2">Double-sided bidder paddle to be used for Paddle Raise and Live Auction.</div>                                                
                                    </div>
                                </div>
                                <div class="row justify-content-center mb-4">
                                    <div class="col col text-left">
                                        <div class="mb-2"><i class="fas fa-print mr-1"></i>Printing instructions </div>
                                        <div class="body-2">
                                            Print it on letter-size paper with the scale set to 100%. Either print it on A3 size paper and fold it in the middle or print Double Sided on A4/Letter size paper.
                                        </div>                                                
                                    </div>
                                </div>
                                <div class="row justify-content-center">
                                    <div class="col text-center">
                                        <button class="btn btn--paybee btn--purple button waves-effect waves-light" id="doubleSidedFullPagePreview" style="display: initial;">
                                            <i class="fas fa-download mr-2"></i>View and Download
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div class="col-6" style="border-right: #ddd;border-right-style: solid;border-right-width: 0.25px;">
                                <div class="row">
                                    <div class="col-6 text-left body-2">
                                        Front Image
                                        <img class="img-fluid paddle_preview_image" src="/images/double_sided.png" alt="user image" style="width: 100%">
                                    </div>
                                    <div class="col-6 text-left body-2">
                                        Back Image
                                        <img class="img-fluid paddle_preview_image" src="/images/double_sided.png" alt="user image" style="width: 100%">
                                    </div>
                                </div>                                        
                            </div>                                    
                        </div>
                    </div>
                    <!-- Full Page single sided Paddles -->
                    <div class="card text-center card-body" style="margin-bottom: 2rem;"> 
                        <div class="row">                
                            <div class="col-6">                                                                             
                                <div class="row">
                                    <div class="col text-left">                                                
                                        <h5 class="headline-6">
                                            Single Sided Full Page (Letter/A4) One Side Image Bidder Paddles
                                        </h5>
                                    </div>
                                </div>
                                <div class="row justify-content-center mb-4" >
                                    <div class="col">                                                                                                
                                        <div class="text-left body-2">Single-sided bidder paddle with uploaded image on one side. </div>                                                
                                    </div>
                                </div>
                                <div class="row justify-content-center mb-4">
                                    <div class="col col text-left">
                                        <div class="mb-2"><i class="fas fa-print mr-1"></i>Printing instructions </div>
                                        <div class="body-2">
                                            Print it on letter-size paper with the scale set to 100%. Either print it on A3 size paper and fold it in the middle or print Double Sided on A4/Letter size paper.
                                        </div>
                                    </div>
                                </div>
                                <div class="row justify-content-center">
                                    <div class="col text-center">
                                        <button class="btn btn--paybee btn--purple button waves-effect waves-light" id="oneSidedFullPagePaddlePreview" style="display: initial;">
                                            <i class="fas fa-download mr-2"></i>View and Download
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div class="col-6" style="border-right: #ddd;border-right-style: solid;border-right-width: 0.25px;">
                                <div class="row">
                                    <div class="col-6 text-left body-2">
                                        Front Image
                                        <img class="img-fluid paddle_preview_image" src="/images/double_sided.png" alt="user image" style="width: 100%">
                                    </div>
                                    <div class="col-6 text-left body-2">
                                        Back Image
                                        <div class="file-field">
                                            <div class="d-flex justify-content-left">
                                                <div class="btn btn-flat waves-effect waves-effect p-0 m-0 w-100">
                                                    <img class="img-fluid paddle_preview_image" id="paddleBackImageFullPage" src="/images/one_side_image_place_holder.png" alt="user image" style="width: 100%">
                                                    <input id="uploadPaddleImageFullPage" type="file" onclick="this.value=null;">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="text-center body-2 mt-1">Click on image to add/update</div>
                                    </div>
                                </div>                                        
                            </div>                                    
                        </div>
                    </div>
                    <!-- Double Sided tented table cards -->
                    <div class="card text-center card-body" style="margin-bottom: 2rem;"> 
                        <div class="row">                
                            <div class="col-6">                                                                             
                                <div class="row">
                                    <div class="col text-left">                                                
                                        <h5 class="headline-6">
                                            Double Sided Table Cards
                                        </h5>
                                    </div>
                                </div>
                                <div class="row justify-content-center mb-4" >
                                    <div class="col">                                                                                                
                                        <div class="text-left body-2">Double sided tented table cards.</div>
                                    </div>
                                </div>
                                <div class="row justify-content-center mb-4">
                                    <div class="col col text-left">
                                        <div class="mb-2"><i class="fas fa-print mr-1"></i>Printing instructions </div>
                                        <div class="body-2">
                                            Print it on letter size paper with scale set to 100% and pages per sheet of 4.
                                            Fold it in the middle to create tented table cards.
                                        </div>                                                
                                    </div>
                                </div>
                                <div class="row justify-content-center">
                                    <div class="col text-center">
                                        <button class="btn btn--paybee btn--purple button waves-effect waves-light" id="pdfTableCardPreview"  style="display: initial;">
                                            <i class="fas fa-download mr-2"></i>View and Download
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div class="col-6" style="border-right: #ddd;border-right-style: solid;border-right-width: 0.25px;">
                                <div class="row">
                                    <div class="col-6 text-left body-2">
                                        Front Image
                                        <img class="img-fluid paddle_preview_image" src="/images/table_card_front.png" alt="user image" style="width: 100%">
                                    </div>
                                    <div class="col-6 text-left body-2">
                                        Back Image
                                        <img class="img-fluid paddle_preview_image" src="/images/table_card_back.png" alt="user image" style="width: 100%">
                                    </div>
                                </div>                                        
                            </div>                                    
                        </div>
                    </div>
                    <!-- 2"x3.5" Landscape name cards -->
                    <div class="card text-center card-body" style="margin-bottom: 2rem;"> 
                        <div class="row">                
                            <div class="col-6">                                                                             
                                <div class="row">
                                    <div class="col text-left">                                                
                                        <h5 class="headline-6">
                                            3.5x2&#8220; Name Cards
                                        </h5>
                                    </div>
                                </div>
                                <div class="row justify-content-center mb-4">
                                    <div class="col">                                                                                                
                                        <div class="text-left body-2">3.5x2&#8220; Landscape Name Cards</div>                                                
                                    </div>
                                </div>
                                <div class="row justify-content-center mb-4">
                                    <div class="col col text-left">
                                        <div class="mb-2"><i class="fas fa-print mr-1"></i>Printing instructions </div>
                                        <div class="body-2">
                                            Print it on letter size paper with scale set to 100%.
                                            Conform to the size of Avery 5371 sticker paper or similar template. Each page has 10 cards.
                                        </div>
                                    </div>
                                </div>
                                <div class="row justify-content-center">
                                    <div class="col text-center">
                                        <button class="btn btn--paybee btn--purple button waves-effect waves-light" id="pdfNameCardPreview" style="display: initial;">
                                            <i class="fas fa-download mr-2"></i>View and Download
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div class="col-6" style="border-right: #ddd;border-right-style: solid;border-right-width: 0.25px;">
                                <div class="row">
                                    <div class="col-6 text-left body-2">
                                        Front Image                                                
                                        <img class="img-fluid paddle_preview_image" src="/images/name_card_front.png" alt="user image" style="width: 100%">
                                    </div>
                                    <div class="col-6 text-left body-2">
                                    </div>
                                </div>                                        
                            </div>                                    
                        </div>
                    </div>
                    <!-- 3.5"x2" Potrait name cards -->
                    <div class="card text-center card-body" style="margin-bottom: 2rem;"> 
                        <div class="row">                
                            <div class="col-6">                                                                             
                                <div class="row">
                                    <div class="col text-left">                                                
                                        <h5 class="headline-6">
                                            2&#8220; x 3.5&#8220; Portrait Name Cards
                                        </h5>
                                    </div>
                                </div>
                                <div class="row justify-content-center mb-4" >
                                    <div class="col">                                                                                                
                                        <div class="text-left body-2">2x3.5&#8220; Portrait Name Cards</div>                                                
                                    </div>
                                </div>
                                <div class="row justify-content-center mb-4">
                                    <div class="col col text-left">
                                        <div class="mb-2"><i class="fas fa-print mr-1"></i>Printing instructions </div>
                                        <div class="body-2">
                                            Print it on letter size paper in with scale set to 100% in landscape mode to fit Avery 5371 sticker paper or similar template.
                                            Each page has 10 cards.
                                        </div>                                                
                                    </div>
                                </div>
                                <div class="row justify-content-center">
                                    <div class="col text-center">
                                        <button class="btn btn--paybee btn--purple button waves-effect waves-light" id="pdfNameCardVerticalPreview" style="display: initial;">
                                            <i class="fas fa-download mr-2"></i>View and Download
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div class="col-6" style="border-right: #ddd;border-right-style: solid;border-right-width: 0.25px;">
                                <div class="row">
                                    <div class="col-6 text-left body-2">
                                        Front Image
                                        <img class="img-fluid paddle_preview_image" src="/images/name_card_vertical.png" alt="user image" style="width: 100%">
                                    </div>
                                    <div class="col-6 text-left body-2">
                                    </div>
                                </div>                                        
                            </div>                                    
                        </div>
                    </div>
                    <!-- Avery_5395 2-1/4" x 3-1/2" name cards 8 per page-->
                    <div class="card text-center card-body" style="margin-bottom: 2rem;"> 
                        <div class="row">                
                            <div class="col-6">                                                                             
                                <div class="row">
                                    <div class="col text-left">                                                
                                        <h5 class="headline-6">
                                            2.25&#8220; x 3.5&#8220; Name Cards
                                        </h5>
                                    </div>
                                </div>
                                <div class="row justify-content-center mb-4" >
                                    <div class="col">                                                                                                
                                        <div class="text-left body-2">2.25x3.5&#8220; Name Cards</div>                                                
                                    </div>
                                </div>
                                <div class="row justify-content-center mb-4">
                                    <div class="col col text-left">
                                        <div class="mb-2"><i class="fas fa-print mr-1"></i>Printing instructions </div>
                                        <div class="body-2">
                                            Print it on letter size paper in with scale set to 100% mode to fit Avery 5395 sticker paper or similar template.
                                            Each page has 8 cards.
                                        </div>                                                
                                    </div>
                                </div>
                                <div class="row justify-content-center">
                                    <div class="col text-center">
                                        <button class="btn btn--paybee btn--purple button waves-effect waves-light" id="pdfNameAvery5395Preview" style="display: initial;">
                                            <i class="fas fa-download mr-2"></i>View and Download
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div class="col-6" style="border-right: #ddd;border-right-style: solid;border-right-width: 0.25px;">
                                <div class="row">
                                    <div class="col text-left body-2">
                                        Front Image
                                        <img class="img-fluid paddle_preview_image" src="/images/name_card_5395.png" alt="user image" style="width: 100%">
                                    </div>
                                </div>                                        
                            </div>                                    
                        </div>
                    </div>
                    <!-- Avery_5392 3" x 4" name cards 6 per page-->
                    <div class="card text-center card-body" style="margin-bottom: 2rem;"> 
                        <div class="row">                
                            <div class="col-6">                                                                             
                                <div class="row">
                                    <div class="col text-left">                                                
                                        <h5 class="headline-6">
                                            3&#8220; x 4&#8220; Name Cards
                                        </h5>
                                    </div>
                                </div>
                                <div class="row justify-content-center mb-4" >
                                    <div class="col">                                                                                                
                                        <div class="text-left body-2">3x4&#8220; Name Cards</div>                                                
                                    </div>
                                </div>
                                <div class="row justify-content-center mb-4">
                                    <div class="col col text-left">
                                        <div class="mb-2"><i class="fas fa-print mr-1"></i>Printing instructions </div>
                                        <div class="body-2">
                                            Print it on letter size paper in with scale set to 100% in landscape mode to fit Avery 5392 sticker paper or similar template.
                                            Each page has 6 cards.
                                        </div>                                                
                                    </div>
                                </div>
                                <div class="row justify-content-center">
                                    <div class="col text-center">
                                        <button class="btn btn--paybee btn--purple button waves-effect waves-light" id="pdfNameCardAvery5392Preview" style="display: initial;">
                                            <i class="fas fa-download mr-2"></i>View and Download
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div class="col-6" style="border-right: #ddd;border-right-style: solid;border-right-width: 0.25px;">
                                <div class="row">
                                    <div class="col text-left body-2">
                                        Image
                                        <img class="img-fluid paddle_preview_image" src="/images/name_card_5392.png" alt="user image" style="width: 100%">
                                    </div>
                                </div>                                        
                            </div>                                    
                        </div>
                    </div>
                    <!-- 3" x 1.188" Name Badges -->
                    <div class="card text-center card-body" style="margin-bottom: 2rem;"> 
                        <div class="row">                
                            <div class="col-6">                                                                             
                                <div class="row">
                                    <div class="col text-left">                                                
                                        <h5 class="headline-6">
                                            3&#8220; x 1.188&#8220; Name Badges
                                        </h5>
                                    </div>
                                </div>
                                <div class="row justify-content-center mb-4" >
                                    <div class="col">                                                                                                
                                        <div class="text-left body-2">3&#8220; wide x 1.188&#8220; name cards (without QR codes) that can added to magnetized badges.</div>
                                    </div>
                                </div>
                                <div class="row justify-content-center mb-4">
                                    <div class="col col text-left">
                                        <div class="mb-2"><i class="fas fa-print mr-1"></i>Printing instructions </div>
                                        <div class="body-2">
                                            Print it on letter size paper with scale set to 100%. Each page has 14 name cards.
                                        </div>                                                
                                    </div>
                                </div>
                                <div class="row justify-content-center">
                                    <div class="col text-center">
                                        <button class="btn btn--paybee btn--purple button waves-effect waves-light" id="pdfNameCard3x1_88Preview" style="display: initial;">
                                            <i class="fas fa-download mr-2"></i>View and Download
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div class="col-6" style="border-right: #ddd;border-right-style: solid;border-right-width: 0.25px;">
                                <div class="row">
                                    <div class="col-6 text-left body-2">
                                        Image
                                        <img class="img-fluid paddle_preview_image" src="/images/3x1.188-preview.png" alt="user image" style="width: 100%">
                                    </div>
                                </div>                                        
                            </div>   
                        </div>
                    </div>
                    <!-- 1.5"x1.5" QR code only -->
                    <div class="card text-center card-body" style="margin-bottom: 2rem;"> 
                        <div class="row">                
                            <div class="col-6">                                                                             
                                <div class="row">
                                    <div class="col text-left">                                                
                                        <h5 class="headline-6">
                                            1.5&#8220; x 1.5&#8220; QR Codes Only
                                        </h5>
                                    </div>
                                </div>
                                <div class="row justify-content-center mb-4" >
                                    <div class="col">                                                                                                
                                        <div class="text-left body-2">Just self checkout QR code, good if you have your own paddles.</div>                                                
                                    </div>
                                </div>
                                <div class="row justify-content-center mb-4">
                                    <div class="col col text-left">
                                        <div class="mb-2"><i class="fas fa-print mr-1"></i>Printing instructions </div>
                                        <div class="body-2">
                                            Print it on letter size paper with scale set to 100%. Print it on Avery 22805 or similar template. 24 on each page.
                                        </div>                                                
                                    </div>
                                </div>
                                <div class="row justify-content-center">
                                    <div class="col text-center">
                                        <button class="btn btn--paybee btn--purple button waves-effect waves-light" id="pdfQrCodeOnlyPreview" style="display: initial;">
                                            <i class="fas fa-download mr-2"></i>View and Download
                                        </button>
                                        <button (click)="openSelectSizeModal()" class="btn btn--paybee btn--purple button waves-effect waves-light ml-2" style="display: initial;">
                                            <i class="fas fa-download mr-2"></i>Download Excel
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div class="col-6" style="border-right: #ddd;border-right-style: solid;border-right-width: 0.25px;">
                                <div class="row">
                                    <div class="col-6 text-left body-2">
                                        Front Image
                                        <img class="img-fluid paddle_preview_image" src="/images/qr_code_only.png" alt="user image" style="width: 100%">
                                    </div>
                                    <div class="col-6 text-left body-2">
                                    </div>
                                </div>                                        
                            </div>                                    
                        </div>
                    </div>    
                    <!-- Small Stickers Paddles -->
                    <div class="card text-center card-body" style="margin-bottom: 2rem;"> 
                        <div class="row">                
                            <div class="col-6">                                                                             
                                <div class="row">
                                    <div class="col text-left">                                                
                                        <h5 class="headline-6">
                                            Small Paddle Stickers
                                        </h5>
                                    </div>
                                </div>
                                <div class="row justify-content-center mb-4" >
                                    <div class="col">                                                                                                
                                        <div class="text-left body-2">Small stickers paddle to be used for offline bidding/pledging using paddle number</div>                                                
                                    </div>
                                </div>
                                <div class="row justify-content-center mb-4">
                                    <div class="col col text-left">
                                        <div class="mb-2"><i class="fas fa-print mr-1"></i>Printing instructions </div>
                                        <div class="body-2">
                                            Print it on Avery Template Presta® 94203 or equivalent sticker paper with the scale set to 100%
                                        </div>                                                
                                    </div>
                                </div>
                                <div class="row justify-content-center">
                                    <div class="col text-center">
                                        <button class="btn btn--paybee btn--purple button waves-effect waves-light" id="pdfSMSTicketersPaddlePreview" style="display: initial;">
                                            <i class="fas fa-download mr-2"></i>View and Download
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div class="col-6" style="border-right: #ddd;border-right-style: solid;border-right-width: 0.25px;">
                                <div class="row">
                                    <div class="col-6 text-left body-2">
                                        Image
                                        <img class="img-fluid paddle_preview_image w-100" src="/images/small_ticket_paddles.png" alt="Paddle image">
                                    </div>
                                    
                                </div>                                        
                            </div>                                    
                        </div>
                    </div>     
                    <!-- Golf Cart Signs -->
                    <div id="golfCartSignPaddlesDiv" class="card text-center card-body" style="margin-bottom: 2rem; display: none;"> 
                        <div class="row">                
                            <div class="col-6">                                                                             
                                <div class="row">
                                    <div class="col text-left">                                                
                                        <h5 class="headline-6">
                                            Golf Cart Signs
                                        </h5>
                                    </div>
                                </div>
                                <div class="row justify-content-center mb-4" >
                                    <div class="col">                                                                                                
                                        <div class="text-left body-2">Download and print signs showing player names, starting holes, and cart assignments to display on each golf cart.</div>
                                    </div>
                                </div>
                                <div class="row justify-content-center mb-4">
                                    <div class="col col text-left">
                                        <div class="mb-2"><i class="fas fa-print mr-1"></i>Printing instructions </div>
                                        <div class="body-2">
                                            Print it on letter size paper.
                                        </div>                                                
                                    </div>
                                </div>
                                <div class="row justify-content-center">
                                    <div class="col text-center">
                                        <button class="btn btn--paybee btn--purple button waves-effect waves-light" id="pdfGolfCartSignPreview" style="display: initial;">
                                            <i class="fas fa-download mr-2"></i>View and Download
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div class="col-6" style="border-right: #ddd;border-right-style: solid;border-right-width: 0.25px;">
                                <div class="row">
                                    <div class="col-6 text-left body-2">
                                        Image
                                        <img class="img-fluid paddle_preview_image" src="/images/golf_cart_sign.png" alt="Golf Cart Sign" style="width: 100%">
                                    </div>
                                </div>                                        
                            </div>   
                        </div>
                    </div>
                </div>
            </div>
            <div class="tab-pane fade" id="panelInPersonEventPageInvite" role="tabpanel">
                <div class="d-flex">
                    <div class="d-block w-100">
                        <div class="ticket-summary__holder headline-5 mb-2 mt-2">Event Page Invitations
                            <a id="refreshEventPage" onclick="" class="blue-text ticket-summary__type">
                                <i class="fas fa-sync"></i>
                            </a>
                        </div>
                        <div class="ticket-summary__type body-2 grey-text mb-2" id="vEventNameReport">Invitations for the registartion through event page.</div>
                    </div>
                    <div class="d-block">
                        <div class="d-flex w-100">
                            <div>
                                <button id="sendNewInPersonEventPageInvites" type="button" class="btn btn-sm modal-cancel-button waves-effect waves-light caption text-nowrap" aria-expanded="false"><i class="fa fa-user-plus mr-2"></i>Invite...</button>
                            </div>
                            <div>
                                <button type="button" data-toggle="dropdown" class="btn btn-sm modal-cancel-button waves-effect waves-light caption text-nowrap">
                                    <i class="fas fa-paper-plane mr-2"></i>
                                    <span class="mr-2">Reminders</span>
                                    <i class="fas fa-caret-down"></i>
                                </button>
                                <ul class="dropdown-menu dropdown-menu-right">
                                    <li class="dropdown-item body-1" id="remindInPersonEventPageInvitees"><a>Reminder...</a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
    
                <div id="eventPageInvitationStatistic">
                    <div class="row mx-0 mb-2 mt-4">
                        <div class="d-flex col-12 col-sm-6 col-md-4 col-xl-3 justify-content-center mb-2 mb-md-0 offset-xl-1">
                            <div class="d-flex align-items-center">
                                <i class="fas fa-paper-plane mr-2"></i>
                                <div class="body-1 text-nowrap"><span id="eventPageInPersonInvitationStatisticSent">0</span> Sent</div>
                            </div>
                        </div>
                        <div class="d-flex col-12 col-sm-6 col-md-4 col-xl-4 justify-content-center mb-2 mb-md-0">
                            <div class="d-flex align-items-center">
                                <i class="fas fa-eye mr-2"></i>
                                <div class="body-1 text-nowrap"><span id="eventPageInPersonInvitationStatisticOpened">0</span> Opened</div>
                            </div>
                        </div>
                        <div class="d-flex col-12 col-md-4 col-xl-3 justify-content-center mb-2 mb-md-0">
                            <div class="d-flex align-items-center">
                                <i class="fas fa-question mr-2 red-text"></i>
                                <div class="body-1 text-nowrap"><span id="eventPageInPersonInvitationStatisticBounced">0</span> Bounced</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="table--paybee">
                    <div class='text-center no-data-text' style="display: none" id="emptyInPersonEventPageInviteList">No invitations yet.</div>
                    <table id="inPersonEventPageInviteList" class="table" cellspacing="0" style="width: 100%;">
                        <thead class="thead-light">
                            <tr>
                                <th class="no-export">Actions</th>
                                <th>Name</th>
                                <th>Email</th>
                                <th>Updated</th>
                                <th>Status</th>
                                <th>Reminded</th>
                            </tr>
                        </thead>
                    </table>
                </div>
            </div>
            <div class="tab-pane fade" id="panelInPersonReminders" role="tabpanel" data-page="scheduleReminder">
                <div class="accordion md-accordion" id="scheduleReminderAccordion" style="border:none !important;" role="tablist" aria-multiselectable="true">

                    <div class="d-flex align-items-center justify-content-between mb-3">
                        <div class="headline-4 px-3">Reminders</div>
                        <div class="d-flex flex-column">
                            <div class="d-flex flex-row justify-content-end mb-2">
                                <div>
                                    <button type="button" data-toggle="dropdown" class="btn btn--paybee btn--outline-transparent btn--padding10x15 button btn--solid-border waves-effect waves-light my-0 ml-0 mr-2 shadow-none" aria-expanded="false">
                                        <i class="fas fa-paper-plane mr-2"></i>
                                        <span class="mr-2">Send Now</span>
                                        <i class="fas fa-caret-down"></i>
                                    </button>
                                    <ul class="dropdown-menu dropdown-menu-right" x-placement="bottom-end" style="position: absolute; will-change: transform; top: 0px; left: 0px; transform: translate3d(1424px, 42px, 0px);">
                                        <li class="dropdown-item body-1" id="sendCartReminderAllRemTab"><a>Pending Carts...</a></li>
                                        <li class="dropdown-item body-1" id="sendGuestReminderAllRemTab"><a>Event Reminder...</a></li>
                                        <li class="dropdown-item body-1" id="sendAddGuestReminderAllRemTab">
                                            <a>Add Guest Reminder...</a>
                                            <div id="sendAddGuestReminderAllRemTabError" class="caption red-text">Event date is in the past</div>
                                        </li>
                                        <li class="dropdown-item body-1" id="sendSaveCardReminderAllRemTab">
                                            <a>Save Card Reminder...</a>
                                            <div id="sendSaveCardReminderAllRemTabError" class="caption red-text">Event date is in the past</div>
                                        </li>
                                    </ul>
                                </div>
                                <div>

                                    <button type="button" data-toggle="dropdown" class="btn btn--paybee btn--outline-transparent btn--padding10x15 button btn--solid-border waves-effect waves-light my-0 ml-0 shadow-none">
                                        <i class="fas fa-paper-plane mr-2"></i>
                                        <span class="mr-2">Schedule</span>
                                        <i class="fas fa-caret-down"></i>
                                    </button>
                                    <ul class="dropdown-menu dropdown-menu-right">
                                        <li data-id="scheduleCustomReminder_3" data-task-type="3" data-action="scheduleCustomReminder" class="dropdown-item body-1">
                                            <a>Pending Carts Reminder...</a>
                                        </li>
                                        <li data-id="scheduleCustomReminder_7" data-task-type="7" data-action="scheduleCustomReminder" class="dropdown-item body-1">
                                            <a>Event Reminder...</a>
                                            <div data-id="scheduleCustomReminder_7_error" class="caption red-text">Event date is in the past</div>
                                        </li>
                                        <li data-id="scheduleCustomReminder_8" data-task-type="8" data-action="scheduleCustomReminder" class="dropdown-item body-1">
                                            <a>Add Guest Reminder...</a>
                                            <div data-id="scheduleCustomReminder_8_error" class="caption red-text">Event date is in the past</div>
                                        </li>
                                        <li data-id="scheduleCustomReminder_10" data-task-type="10" data-action="scheduleCustomReminder" class="dropdown-item body-1">
                                            <a>Event Page Invite Reminder...</a>
                                            <div data-id="scheduleCustomReminder_10_error" class="caption red-text">Event date is in the past</div>
                                        </li>
                                        <li data-id="scheduleCustomReminder_13" data-task-type="13" data-action="scheduleCustomReminder" class="dropdown-item body-1">
                                            <a>Save Card Reminder...</a>
                                            <div data-id="scheduleCustomReminder_13_error" class="caption red-text">Event date is in the past</div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div id="eventDateTime" class="body-1"></div>
                        </div>
                    </div>

                    <div class="card" data-section="suggestedReminderCard">
                        <div class="card-header px-1" role="tab" id="suggestedReminderHeading" data-section="suggestedReminderHeading">
                            <a id="suggestedReminderHeadingLink" class="accordion-button--scheduller collapsed" data-toggle="collapse" href="#suggestedReminderCollapse" aria-expanded="false" aria-controls="suggestedReminderCollapse">
                                <span class="headline-6 black-text pl-5 mb-2">Suggested</span>
                            </a>
                        </div>

                        <div id="suggestedReminderCollapse" class="collapse" role="tabpanel" aria-labelledby="suggestedReminderHeading">
                            <div class="card-body pt-0 px-0">
                                <div class="col-12 col-xl-10" id="recommendationListContainer" data-section="suggestedReminderListContainer"></div>
                            </div>
                        </div>
                    </div>

                    <div class="card" data-section="scheduledReminderCard">
                        <div class="card-header px-1" role="tab" id="scheduledReminderHeading" data-section="scheduledReminderHeading">
                            <a id="scheduledReminderHeadingLink" class="accordion-button--scheduller collapsed" data-toggle="collapse" href="#scheduledReminderCollapse" aria-expanded="false" aria-controls="scheduledReminderCollapse">
                                <span class="headline-6 black-text pl-5 mb-2">Scheduled</span>
                            </a>
                        </div>

                        <div id="scheduledReminderCollapse" class="collapse" role="tabpanel" aria-labelledby="scheduledReminderHeading">
                            <div class="card-body pt-0 px-0">
                                <div class="col-12 col-xl-10" id="scheduledListContainer" data-section='scheduledReminderListContainer'></div>
                            </div>
                        </div>
                    </div>

                    <div class="card" data-section="completedReminderCard">
                        <div class="card-header px-1" role="tab" id="completedReminderHeading" data-section="completedReminderHeading">
                            <a id="completedReminderHeadingLink" class="accordion-button--scheduller collapsed" data-toggle="collapse" href="#completedReminderCollapse" aria-expanded="false" aria-controls="completedReminderCollapse">
                                <span class="headline-6 black-text pl-5 mb-2">Completed</span>
                            </a>
                        </div>

                        <div id="completedReminderCollapse" class="collapse" role="tabpanel" aria-labelledby="completedReminderHeading">
                            <div class="card-body pt-0 px-0">
                                <div class="col-12 col-xl-10" id="completedListContainer" data-section='completedReminderListContainer'></div>
                            </div>
                        </div>
                    </div>

                    <div class="card" data-section="cancelledReminderCard">
                        <div class="card-header px-1" role="tab" id="cancelledReminderHeading" data-section="cancelledReminderHeading">
                            <a id="cancelledReminderHeadingLink" class="accordion-button--scheduller collapsed" data-toggle="collapse" href="#cancelledReminderCollapse" aria-expanded="false" aria-controls="cancelledReminderCollapse">
                                <span class="headline-6 black-text pl-5 mb-2">Cancelled</span>
                            </a>
                        </div>

                        <div id="cancelledReminderCollapse" class="collapse" role="tabpanel" aria-labelledby="cancelledReminderHeading">
                            <div class="card-body pt-0 px-0">
                                <div class="col-12 col-xl-10" id="cancelledListContainer" data-section='cancelledReminderListContainer'></div>
                            </div>
                        </div>
                    </div>
                    
                </div>
            </div>
        </div>
    </div>
</div>
<div id="runEventStyles" #container></div>